import { render, staticRenderFns } from "./LeadsSettings.vue?vue&type=template&id=25246ecb&scoped=true&"
import script from "./LeadsSettings.vue?vue&type=script&lang=js&"
export * from "./LeadsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25246ecb",
  null
  
)

export default component.exports